if (!customElements.get('koji-hero')) {
  customElements.define('koji-hero', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const signal = this.abort.signal;
      const track = this.querySelector('.kh__track');
      const slides = [...this.querySelectorAll('.kh__slide')];
      const controls = this.querySelector('.kh__controls');
      if (!track || !controls || slides.length < 2) return;
      controls.hidden = false;
      const prev = controls.querySelector('[data-prev]');
      const next = controls.querySelector('[data-next]');
      const count = controls.querySelector('[data-count]');
      const current = () => Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
      const update = () => { const i = current(); count.textContent = `${String(i + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`; prev.disabled = i === 0; next.disabled = i === slides.length - 1; };
      const go = i => track.scrollTo({left: Math.max(0, Math.min(slides.length - 1, i)) * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      prev.addEventListener('click', () => go(current() - 1), {signal});
      next.addEventListener('click', () => go(current() + 1), {signal});
      track.addEventListener('scroll', update, {passive:true, signal});
      track.addEventListener('keydown', e => {if(e.target !== track) return; if(e.key === 'ArrowRight' || e.key === 'ArrowLeft'){e.preventDefault();go(current() + (e.key === 'ArrowRight' ? 1 : -1));}}, {signal});
      this.addEventListener('shopify:block:select', e => {const i=slides.findIndex(s=>s.contains(e.target));if(i>=0)go(i);}, {signal});
      this.resize = new ResizeObserver(update); this.resize.observe(track); update();
    }
    disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();}
  });
}
